// extracted by mini-css-extract-plugin
module.exports = {"up":"ChevronIcon_up__hqXGV","bottom":"ChevronIcon_bottom__OcJIQ","left":"ChevronIcon_left__qome2","right":"ChevronIcon_right__QqOt_"};